/**
 * @file
 * Provide configurations of carousels.
 * Use slick library to build carousel elements.
 */

(function ($, Drupal) {
  Drupal.behaviors.slideShow = {
    attach: function attach(context) {
      const slickContainerSelector = '.js-slide-show';
      once('awSlideShow', `${slickContainerSelector} .gallery__container`, context).forEach(function(currentElement) {
        const $slickElement = $(currentElement);

        $slickElement.on('init', function (event, slick) {
          let $pagination = $(this).parents('.slide-show').find('.slide-show__pagination');
          let $paginationTranslationArgs = {};
          $paginationTranslationArgs['!current'] = 1;
          $paginationTranslationArgs['!count'] = slick.slideCount;
          $pagination.text(Drupal.t('Image !current of !count', $paginationTranslationArgs));
        });

        $slickElement.on('afterChange', function (event, slick, currentSlide) {
          let $pagination = $(this).parents('.slide-show').find('.slide-show__pagination');
          let $paginationTranslationArgs = {};
          $paginationTranslationArgs['!current'] = (currentSlide ? currentSlide : 0) + 1;
          $paginationTranslationArgs['!count'] = slick.slideCount;

          $pagination.text(Drupal.t('Image !current of !count', $paginationTranslationArgs));
        });

        $slickElement.slick({
          dots: false,
          infinite: false,
          speed: 200,
          rows: 0,
          cssEase: 'ease',
          prevArrow: $slickElement.closest(slickContainerSelector).siblings('.slide-show__controls').find('.slide-show__arrow--prev'),
          nextArrow: $slickElement.closest(slickContainerSelector).siblings('.slide-show__controls').find('.slide-show__arrow--next')
        });
      })
    }
  };

  Drupal.behaviors.tileCarousel = {
    attach: function attach(context) {
      once('awTileCarousel', '.js-tile-carousel', context).forEach(function(currentElement) {
        let currentElementJquery = $(currentElement);
        currentElementJquery.on('setPosition', function () {
          Drupal.attachBehaviors(document, Drupal.settings);
        });

        currentElementJquery.slick({
          dots: true,
          infinite: true,
          speed: 200,
          cssEase: 'ease',
          slidesToShow: 4,
          slidesToScroll: 4,
          rows: 0,
          prevArrow: currentElementJquery.siblings('.tile-carousel-controls').find('.tile-carousel-controls__arrow--prev'),
          nextArrow: currentElementJquery.siblings('.tile-carousel-controls').find('.tile-carousel-controls__arrow--next'),
          responsive: [
            {
              breakpoint: 1060,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        if (currentElementJquery.attr('class').indexOf('js-tile-carousel-small') >= 0) {
          currentElementJquery.slick('slickSetOption', 'slidesToShow', 3, true);
          currentElementJquery.slick('slickSetOption', 'slidesToScroll', 3, true);
        }
      });

    }
  };

})(jQuery, Drupal);
